import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesPenalizadosActions'
import { TablaCamionesPenalizadosView } from '../components/TablaCamionesPenalizadosView'

class TablaCamionesPenalizados extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaCamionesPenalizadosView />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaCamionesPenalizados)
